import { theme } from '@unbridaled/theme';
import { extendTailwindMerge } from 'tailwind-merge';
import { clsx as clsx$1 } from 'clsx';
import { cva as cva$1 } from 'class-variance-authority';

const twMerge = extendTailwindMerge({
    prefix: 'uui-',
    extend: {
        classGroups: {
            z: Object.keys(theme.zIndex).map(key => `z-${key}`),
        }
    }
});
const clsx = (...inputs) => {
    return twMerge(clsx$1(inputs));
};
const cva = (base, config) => {
    const fn = cva$1(base, config);
    return (inputs) => twMerge(fn(inputs));
};

export { clsx, cva, twMerge };
//# sourceMappingURL=clsx.mjs.map
